import { formatDate } from "./formatDate";
export const createCARRecord = async (formData, resetForm) => {
  const conn_name = "crmwidgetconnection";

  //Type section checkboxes api name with creator field name
  const typeFields = {
    corrective: { Corrective_action: true },
    preventive: { Preventive_action_potential_issue: true },
    improvement: { Opportunity_for_Improvement_suggestion: true },
  };
  const selectedType = formData.type;
  const actionField =
    selectedType && typeFields[selectedType]
      ? Object.keys(typeFields[selectedType])[0]
      : null;
  // Source section checkboxes api name with creator field name
  const SourceFields = {
    Employeecheckbox: { Employee_Source_Creator: true },
    CustomerSource: { CustomerSourceCreator: true },
    ExternalAuditFinding: { ExternalAuditFindingCreator: true },
    InternalAuditFinding: { InternalAuditFindingCreator: true },
    SupplierSource: { SupplierSourceCreator: true },
    ManagementReview: { ManagementReviewCreator: true },
    OtherSource: { OtherSourceCreator: true },
  };
  const selectedSource = formData.Source;
  const sourceField =
    selectedSource && SourceFields[selectedSource]
      ? Object.keys(SourceFields[selectedSource])[0]
      : null;
  // Process section checkboxes api name with creator field name
  const ProcessFields = {
    EstimatingSchedulingArt: { EstimatingSchedulingArtCreator: true },
    PrintingFinishing: { PrintingFinishingCreator: true },
    PurchasingReceivingShipping: { PurchasingReceivingShippingCreator: true },
    InstallationSource: { InstallationSourceCreator: true },
    Otherprocess: { OtherprocessCreator: true },
  };
  const selectedProcess = formData.Process;
  const processField =
    selectedProcess && ProcessFields[selectedProcess]
      ? Object.keys(ProcessFields[selectedProcess])[0]
      : null;
  // Priority section checkboxes api name with creator field name
  const PriorityFields = {
    LowPriority: { LowPriorityCreator: true },
    MediumPriority: { MediumPriorityCreator: true },
    HighPriority: { HighPriorityCreator: true },
    UrgentCritical: { UrgentCriticalCreator: true },
  };
  const selectedPriority = formData.Priority;
  const priorityField =
    selectedPriority && PriorityFields[selectedPriority]
      ? Object.keys(PriorityFields[selectedPriority])[0]
      : null;

  //Result section checkboxes api name with creator field name
  const ResultFields = {
    PassResult: { PassCreator: true },
    FailResult: { FailCreator: true },
  };
  const selectedResult = formData.Result;
  const resultField =
    selectedResult && ResultFields[selectedResult]
      ? Object.keys(ResultFields[selectedResult])[0]
      : null;

  const payload = {
    parameters: {
      data: {
        //
        CAR_Name: formData.name,
        Status_Kanban: "Total CAR Open",
        CAR_Reported_By: formData.Reported_By,
        CRM_Account_Name_CAR: formData.accountId || "",
        Employee: formData.qualityOwner || "",
        Job_name: formData.soIdPalyoad || "",
        Verified_by: formData.qualityOwner1 || "",
        Machine: formData.MachineID || "",
        Describe_the_issue_or_problem_in_detail:
          formData.Describe_the_issue_or_problem_in_detail || "",
        Containment_Immediate_Corrections: formData.containment || "",
        Root_cause_of_Problem: formData.rootCause || "",
        Action_Plan: formData.actionPlan || "",
        Assignee_Name: formData.Assignee_Name || "",
        CAR_PAR_Assigned_to: formData.assignedTo || "",
        Notes: formData.notes || "",

        ...(actionField ? { [actionField]: true } : {}),
        ...(sourceField ? { [sourceField]: true } : {}),
        ...(processField ? { [processField]: true } : {}),
        ...(priorityField ? { [priorityField]: true } : {}),
        ...(resultField ? { [resultField]: true } : {}),

        // Include all remaining fields from formData, but exclude 'type' to avoid conflicts
        ...Object.fromEntries(
          Object.entries(formData).filter(
            ([key]) =>
              ![
                "name",
                "corrective",
                "preventive",
                "improvement",
                "accountId",
                "qualityOwner",
                //"soIdPalyoad",
                "qualityOwner1",
                "MachineID",
                "Describe_the_issue_or_problem_in_detail",
                "containment",
                "date",
                "Reported_By",
                "type",
                "Source",
                "Priority",
                "Process",
                "Result",
                "PassResult",
                "FailResult",
                "Employeecheckbox",
                "CustomerSource",
                "ExternalAuditFinding",
                "InternalAuditFinding",
                "SupplierSource",
                "ManagementReview",
                "OtherSource",
                "EstimatingSchedulingArt",
                "PrintingFinishing",
                "PurchasingReceivingShipping",
                "InstallationSource",
                "Otherprocess",
                "LowPriority",
                "MediumPriority",
                "HighPriority",
                "UrgentCritical",
                "AssignedDate",
                "respondBy",
                "actionCompleted",
                "rootCause",
                "containment",
                "Action_Plan",
                "Assignee_Name",
                "CAR_PAR_Assigned_to",
                "notes",
              ].includes(key)
          )
        ),
        //below code is for Date fields
        ...formData,
        CAR_Date: formatDate(new Date(formData.date)),
        Date_Assigned: formatDate(new Date(formData.AssignedDate)),
        Respond_by: formatDate(new Date(formData.respondBy)),
        Date_Action_Completed: formatDate(new Date(formData.actionCompleted)),
        Verified_Date: formatDate(new Date(formData.verifiedDate)),
      },
    },
    method: "POST",
    url: "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/form/CAR_PAR",
    param_type: 2,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Record is created:", response);

    return response;
  } catch (error) {
    console.error("Error invoking Zoho connection:", error);
    throw error;
  }
};
